<template>
    <div class="modal-card" v-if="project">
        <header class="modal-card-head">
            <h3 class="modal-card-title" v-if="student">Kontakt {{student.name | prettyName}}</h3>

            <button @click="close" class="delete" :aria-label="$t('global.actions.close')" />
        </header>

        <section class="modal-card-body">
            <div class="columns">
                <div class="column">
                    <steps :step="1"/>

                    <p>For at kontakte {{student.name | prettyName}}, skal du blot vælge opgavetypen, og beskrive opgaven. Husk at denne beskrivelse skal fokusere på selve opgaven. Du får mulighed for at skrive en besked senere.</p>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field :label="$t('global.forms.project.name')"
                             :type="{'is-danger': veeErrors.has('projectName')}"
                             :message="veeErrors.first('projectName')">
                        <b-input v-model="name" name="projectName"
                                 custom-class="data-hj-whitelist"
                                 v-validate="'required'" :data-vv-as="$t('global.forms.project.name')" />
                    </b-field>
                </div>

                <div class="column">
                    <b-field :label="$t('global.forms.project.skill')"
                            :type="{'is-danger': veeErrors.has('selectedSkill')}"
                            :message="veeErrors.first('selectedSkill')">
                        <b-field :addons="false" grouped group-multiline>
                            <b-radio-button size="no-margin-bottom" v-for="skill in skills" v-model="selectedSkill" :key="skill.id"
                                            :native-value="skill" type="is-primary" name="selectedSkill"
                                            v-validate="'required'" :data-vv-as="$t('global.forms.project.skill')" >
                                {{$t('skills.' + skill.name + '.name')}}
                            </b-radio-button>
                        </b-field>
                    </b-field>
                </div>
            </div>

            <div class="columns">
                <div class="column">
                    <b-field :label="$t('global.forms.project.message')"
                             :type="{'is-danger': veeErrors.has('projectMessage')}"
                             :message="veeErrors.first('projectMessage')">
                        <b-input v-model="message" type="textarea" name="projectMessage"
                                 custom-class="data-hj-whitelist"
                                 v-validate="'required'" :data-vv-as="$t('global.forms.project.message')" />
                    </b-field>
                </div>
            </div>
        </section>

        <footer class="modal-card-foot">
            <b-field grouped position="is-right" style="width: 100%">
                <p class="control" v-if="this.veeErrors.any()">
                    <span class="help is-danger is-pulled-right">Du mangler at udfylde et eller flere felter.</span>
                </p>

                <p class="control">
                    <button class="button is-default" @click="close">{{$t('global.actions.cancel')}}</button>

                    <button class="button is-primary"  @click="next" :disabled="this.veeErrors.any()">
                        <span>{{$t('global.actions.next')}}</span>

                        <b-icon icon="chevron-right" />
                    </button>
                </p>
            </b-field>
        </footer>
    </div>
</template>

<script>
    import Steps from '@/taskflex/students/components/contact/Steps';
    import { mapGetters, mapMutations } from 'vuex';
    import moment from 'moment';
    import {
        SET_PROJECT_NAME,
        SET_PROJECT_SKILL,
        SET_PROJECT_MESSAGE,
        SET_PROJECT_STEP,
        STEP_TWO,
    } from '@/taskflex/students/store/contactForm/_types';

    export default {
        data() {
            return {
                name: null,
                selectedSkill: null,
                message: null,
            };
        },

        computed: {
            ...mapGetters('contactForm', [
                'project',
            ]),

            student() {
                const { student } = this.project;

                return student;
            },

            skills() {
                const { skills } = this.student;

                return skills;
            },
        },

        watch: {
            selectedSkill(newSkill, oldSkill) {
                if (!newSkill) {
                    return;
                }

                const { name } = this;
                let oldName;

                if (oldSkill) {
                    oldName = this.generateName(oldSkill);
                }

                // Set a default name if none is set,
                // or it is unchanged from the previous default name.
                if (!name || name === oldName) {
                    this.name = this.generateName(newSkill);
                }
            },
        },

        mounted() {
            this.name = this.project.name;
            this.selectedSkill = this.project.skill;
            this.message = this.project.message;
        },

        methods: {
            ...mapMutations('contactForm', {
                setName: SET_PROJECT_NAME,
                setSkill: SET_PROJECT_SKILL,
                setMessage: SET_PROJECT_MESSAGE,
                setStep: SET_PROJECT_STEP,
            }),

            generateName(skill) {
                const date = moment().format('MMMM Y'); // TODO: I18N.
                const capitalizedDate = date.charAt(0).toUpperCase() + date.slice(1);

                return `${this.$t(`skills.${skill.name}.name`)} - ${capitalizedDate}`;
            },

            async next() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                this.setName(this.name);
                this.setSkill(this.selectedSkill);
                this.setMessage(this.message);

                this.setStep(STEP_TWO);
            },

            close() {
                this.$emit('hide');
            },
        },

        components: {
            Steps,
        },
    };
</script>




// WEBPACK FOOTER //
// src/taskflex/students/components/contact/StepOne.vue